import React, { useState } from 'react';
import { showServerError } from 'bk-web-app';
import { toastError, toastSuccess } from 'bench-internal-theme';
import { useMutation } from '@apollo/client';
import AddonSidebarForm from './AddonSidebarForm';
import type { Addon } from '../types';
import { CREATE_ADDON, GET_ADDONS, UPDATE_ADDON } from '../queries';
import { useClient } from '../../ClientContext';

type AddonSidebarFormContainerProps = {
  addon?: Addon;
  closeSidebar: () => void;
  setAddOnData: (data: Addon) => void;
};

const AddonSidebarFormContainer = ({
  addon,
  closeSidebar,
  setAddOnData,
}: AddonSidebarFormContainerProps) => {
  const client = useClient();

  const refetchQueries = [{ query: GET_ADDONS, variables: { clientId: client?.id } }];

  const [createAddon, { loading: loadingEditAddon }] = useMutation(CREATE_ADDON, {
    onCompleted: createData => {
      toastSuccess('Add-on Created', 'Your add-on has been created.');
      setAddOnData(createData);
    },
    onError: error => {
      toastError('An error occurred creating this add-on.', showServerError(error));
    },
    refetchQueries,
  });
  const [updateAddon, { loading: loadingAddonCreate }] = useMutation(UPDATE_ADDON, {
    onCompleted: updateData => {
      toastSuccess('Add-on Updated', 'Your add-on has been updated.');
      setAddOnData(updateData);
    },
    onError: error => {
      toastError('An error occurred updating this add-on.', showServerError(error));
    },
    refetchQueries,
  });

  const [squareMerchantId] = useState(addon?.squareMerchantId || null);
  const [stripeId] = useState(addon?.stripeId || null);

  const onSubmit = payload => {
    if (addon?.id) {
      return updateAddon({ variables: { addonId: addon?.id, addon: payload } });
    }
    return createAddon({ variables: { addon: payload } });
  };

  return (
    <>
      <AddonSidebarForm
        addon={addon}
        closeSidebar={closeSidebar}
        isSubmitting={loadingAddonCreate || loadingEditAddon}
        onSubmit={payload => onSubmit(payload)}
        squareMerchantId={squareMerchantId}
        stripeId={stripeId}
      />
    </>
  );
};

export default AddonSidebarFormContainer;
